module.exports = __webpack_public_path__ + "static/assets/8a1aab5ccf549623b1dee7274c4eb9d7.png";